import Filter from "./di-badwords/di-badwords";
export default Filter;
